// packages
import max from 'underscore/modules/max.js';
import min from 'underscore/modules/min.js';

window.addEventListener('tmp_resize', compactText);

function compactText() {
  const elements = document.querySelectorAll('.compact-text-js');

  elements.forEach((element) => {
    const clone = element.cloneNode(true);

    // This looks odd, but we need to remove any previously inserted <br>'s to get an accurate
    // reading of how tall the element is
    const brs = clone.querySelectorAll('br');
    brs.forEach((br) => {
      clone.replaceChild(document.createTextNode(' '), br);
    });

    const text = clone.textContent.trim();
    element.innerHTML = text;
    const tokens = text.split(/\s/);
    const result = partition(tokens, [], getHeightInLines(element) - 1);
    element.innerHTML = result.partitions.join('<br>');
  });
}

compactText();

function partition(tokens, partitions, numRemaining) {
  // Cowardly refuse to attempt this for more than 4 partitions, too slow.
  if (numRemaining > 4) {
    return {
      partitions: generatePartition(tokens, []),
      score: 0,
    };
  }

  if (numRemaining === 0) {
    partitions = generatePartition(tokens, partitions);
    return {
      score: scorePartition(partitions),
      partitions: partitions,
    };
  }

  const possibilities = [];
  const startingIndex = partitions.length
    ? partitions[partitions.length - 1]
    : -1;
  for (let i = startingIndex + 1; i < tokens.length - 1; i++) {
    const newPartitions = partitions.slice();
    newPartitions.push(i);
    possibilities.push(partition(tokens, newPartitions, numRemaining - 1));
  }

  return min(possibilities, (d) => d.score);
}

function getHeightInLines(el) {
  const computedStyle = window.getComputedStyle(el);
  return Math.round(
    el.clientHeight / parseInt(computedStyle['line-height'], 10)
  );
}

function generatePartition(tokens, partitionIndexes) {
  if (partitionIndexes.length == 0) {
    return [tokens.join(' ')];
  }

  const result = [];

  partitionIndexes.forEach((index, i) => {
    if (i === 0) {
      result.push(tokens.slice(0, index + 1));
    }
    if (i + 1 == partitionIndexes.length) {
      result.push(tokens.slice(index + 1));
    } else {
      result.push(tokens.slice(index + 1, partitionIndexes[i + 1] + 1));
    }
  });

  return result.map((arr) => arr.join(' '));
}

// Partitions is the list of lines
// returns the mean squared error of the given partition
function scorePartition(/** @type {any[]} */ partitions) {
  const lineMax = max(partitions, (line) => line.length).length;

  return (
    partitions.reduce((memo, line) => {
      return memo + Math.pow(lineMax - line.length, 2);
    }, 0) / partitions.length
  );
}
